/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Crop',
  definitions: {
    '16': {
      viewBox: '0 0 16 17',
      path: (
        <>
          <g clip-path="url(#clip0_5018_9038)">
            <path
              d="M3.33347 0.616211C3.63723 0.616211 3.88347 0.862454 3.88347 1.16621V3.28289L11.6666 3.28289C12.5226 3.28289 13.2166 3.97685 13.2166 4.83289L13.2166 10.9996C13.2166 11.3033 12.9703 11.5496 12.6666 11.5496C12.3628 11.5496 12.1166 11.3033 12.1166 10.9996L12.1166 4.83289C12.1166 4.58436 11.9151 4.38289 11.6666 4.38289L0.666577 4.38289C0.36282 4.38289 0.116577 4.13665 0.116577 3.83289C0.116577 3.52914 0.36282 3.28289 0.666577 3.28289L2.78347 3.28289V1.16621C2.78347 0.862454 3.02971 0.616211 3.33347 0.616211Z"
              fill="currentColor"
            />
            <path
              d="M3.88347 5.99959C3.88347 5.69583 3.63723 5.44958 3.33347 5.44958C3.02971 5.44958 2.78347 5.69583 2.78347 5.99959V12.1663C2.78347 13.0223 3.47743 13.7163 4.33347 13.7163H12.1167V15.8329C12.1167 16.1366 12.363 16.3829 12.6667 16.3829C12.9705 16.3829 13.2167 16.1366 13.2167 15.8329V13.7163H15.3335C15.6372 13.7163 15.8835 13.47 15.8835 13.1663C15.8835 12.8625 15.6372 12.6163 15.3335 12.6163C11.6668 12.6163 8.00015 12.6163 4.33347 12.6163C4.08494 12.6163 3.88347 12.4148 3.88347 12.1663V5.99959Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_5018_9038">
              <rect
                width="16"
                height="16"
                fill="white"
                transform="translate(0 0.5)"
              />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
